import React from 'react';
import PropTypes from 'prop-types';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import AssignButton from './AssignButton';

import styles from './styles.css';

const SingleAssign = ({ onClick }) => (
  <PopOver onToggle={onClick} size="medium" trigger={<AssignButton />}>
    <LoadingSpinner containerClassName={styles['spinner-container']} />
  </PopOver>
);

SingleAssign.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default SingleAssign;
